<template>
    <div>
      <div v-if="type == 'discover'" class="search mt-4">
        <input
            type="text"
            v-model="searchClubInput"
            :placeholder="trans('display_club_link_or_title')"
            name="searchInput"
            ref="searchClubs"
            @input="searchClubsDebounce"
            @keypress.enter.prevent="searchClubs()">
        <input type="submit" class="submit" @click="searchClubs()" v-if="!searchClubInput.length">
        <div class="close searchClose closeSearchDesktop" @click="cleanSearch()" v-if="searchClubInput.length"></div>
      </div>
        <div v-if="clubDates.invited && clubDates.invited.length > 0">
            <div>
                <div class="timeline">
                    {{ trans('clubs.invites') }}
                </div>

                <div class="events" v-for="club in clubDates.invited">
                    <ClubListItem :club="club" :invited="true" />
                </div>
            </div>
        </div>

        <div v-if="clubDates.my_clubs && clubDates.my_clubs.length > 0">
            <div>
                <div class="timeline">
                    {{ trans('clubs.admin') }}
                </div>

                <div class="events" v-for="club in clubDates.my_clubs">
                    <ClubListItem :club="club" />
                </div>
            </div>
        </div>
        
        <div v-if="clubDates.invited && clubDates.accepted.length > 0">
            <div>
                <div class="timeline">
                    {{ trans('clubs.member') }}
                </div>

                <div class="events" v-for="club in clubDates.accepted">
                    <ClubListItem :club="club" :accepted="true" />
                </div>
            </div>
        </div>

        <div v-if="clubDates.discover && clubDates.discover.length > 0">
            <div>
                <div class="timeline" v-if="discoverLowRange.length > 0">
                    {{ trans('clubs.nearby') }}
                </div>

                <div class="events" v-for="club in discoverLowRange">
                    <ClubListItem :club="club" />
                </div>

                <template v-if="discoverHighRange.length > 0">
                    <div class="timeline">
                        {{ trans('clubs.more_clubs') }}
                    </div>

                    <div class="events" v-for="club in discoverHighRange">
                        <ClubListItem :club="club" />
                    </div>
                </template>

                <div class="events" v-if="clubDates.discover_has_more">
                    <a v-if="!clubDates.loading" class="btn load-more"
                     @click="loadMoreClubs">
                        {{ trans('show_more') }}
                    </a>
                    
                    <!-- Preloader -->
                    <div v-else class="b-club__preloader">
                        <img src="/assets/img/preloader.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
        
        <infinite-loading :force-use-infinite-wrapper="getBlockIdForPagination"
                                                  ref="infiniteLoadingClubs"
                                            @infinite="loadClubs"
                                              spinner="bubbles">
                                              
            <div class="event no-events"
                  slot="no-results"
                  v-if="showCreateYourClub" 
                @click="createClub('club')">
                <div class="inner">
                    <div class="title">{{ trans('no_clubs_around') }}</div>
                    <a id="add-event-link">
                        {{ trans('create_your_club') }}
                    </a>
                </div>
            </div>
            <div slot="no-results" v-else></div>

            <div class="event no-events"
                  slot="no-more"
                  v-if="showCreateYourClub"
                @click="createClub('club')">
                <div class="inner">
                    <div class="title">{{ trans('no_more_club_around') }}</div>
                    <a id="add-event-link">
                        {{ trans('create_your_club') }}
                    </a>
                </div>
            </div>
            <div slot="no-more" v-else></div>
        </infinite-loading>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import ClubListItem from '@clubs/views/widgets/club/ListItem.vue';
    import clubsModule  from '@clubs/module/store/type'

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-clubs').default,
        ],
        components: {
            ClubListItem,
        },
        data() {
            return {
                showCreateYourClub: true,
                searchClubInput : ''
            }
        },
        computed: {
            ...mapState({
                myClubs:   'myClubs',
                userIsPro: 'userIsPro'
            }),
            ...mapGetters({
                type:      clubsModule.getters.type,
                clubDates: clubsModule.getters.clubDates
            }),
            discoverLowRange() {
                return this.clubDates.discover && this.clubDates.discover.length > 0
                            ? this.clubDates.discover.filter(i => i.distanceMeters <= 300000)
                            : []
            },
            discoverHighRange() {
                return this.clubDates.discover && this.clubDates.discover.length > 0
                            ? this.clubDates.discover.filter(i => i.distanceMeters > 300000)
                            : []
            },
            getBlockIdForPagination() {
                return app.isDesktop ? '#js-clubs-content' : '.content-wrapper'
            }
        },
        methods: {
            ...mapActions({
                loadMoreClubs: clubsModule.actions.clubs.loadMore,
                signalClubsSeen : 'signalClubsSeen'
            }),
            cleanSearch() {
              this.searchClubInput = '';

              this.$nextTick(() => {
                setTimeout(() => {
                  this.searchClubs();
                });
              });
            },
            searchClubs() {
              if(!this.searchClubInput.length || this.searchClubInput.length > 2){
                this.$store.dispatch(clubsModule.actions.filter.set, {
                  key: 'handle',
                  value: this.searchClubInput
                });
                this.resetClubsAround();
              }
            },
            searchClubsDebounce: _.debounce(function (input) {
              this.searchClubs()
            }, 1000),
        },
        created() {
            console.log('[Clubs] Created')
            app.$on('reload-clubs', this.resetClubsAround)
        },
        mounted(){
          let self = this;
          this.checkAgeConfirmModal(function (){
            self.resetClubsAround();
          });
        },
        activated(){
            console.log('[Clubs] Activated')
            if(this.type === 'my_clubs'){
              this.signalClubsSeen();
            }
        },
        destroyed() {
            console.log('[Clubs] Destroyed')
            app.$off('reload-clubs', this.resetClubsAround)
        },
    }
</script>
